import {webRequest, webNoTokenRequest} from '../api'

// 新增編輯企業費用組合設定
export function createChargeMode(data) {
    return webRequest({
        url:'/v1/oauth/management/bill/set/chargeMode',
        method:'post',
        data: data,
    })
}

// 刪除企業費用組合設定
export function deleteBillCharge(data) {
    return webRequest({
        url:'/v1/oauth/management/bill/chargeMode/delete',
        method:'post',
        data: data,
    })
}

// 企業費用組合設定列表
export function getBillChargeList() {
    return webRequest({
        url:'/v1/oauth/management/bill/chargeMode/list',
        method:'get',
    })
}



// WEBPACK FOOTER //
// ./src/apis/company/billChargeMode.js